<style scoped lang="less">
.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #fff;
	margin-bottom: 20px;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	button:last-child {
		background-color: #ff8300;
	}

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}
.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		// text-align: center;
		color: #333;
		font-weight: 600 !important;
	}
	/deep/ .el-table_16_column_83 {
		text-align: center;
	}

	// /deep/ td {
	// 	text-align: center;
	// }

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}
}

.addstras {
	.addstrascenter {
		.ridioslist {
			border: 1px solid #ccc;
			margin: 20px 0;

			.qustridios {
				background-color: #f2f2f2;
				font-size: 16px;
				padding-left: 10px;
			}
		}

		.qustiopn {
			display: flex;
			align-items: center;
			letter-spacing: 1px;
			margin: 10px;

			p {
				margin: 0 5px;
			}

			.chioce:nth-of-type(2) {
				text-decoration: underline;
				color: rgb(0, 0, 255);
				cursor: pointer;
			}

			div {
				margin-right: 5px;
			}
		}
	}
}

/deep/ .childdia {
	background-color: #eff2fa;

	.el-dialog__body {
		padding: 10px 20px !important;
	}

	.demo-ruleForm {
		margin: 0 0px;
		border-top: 1px solid rgb(112, 182, 3);
		background-color: #fff;
		padding: 20px 20px 0;
	}
}

.boxright {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 20px 0;
}

.chioscelist {
	width: 100%;
	padding-bottom: 20px;

	.chiose {
		width: 100%;
		border: 1px solid;
		height: 100px;
		border: 1px solid #ccc;
		border-radius: 5px;
		display: flex;
		flex-wrap: wrap;
		overflow: scroll;
		padding: 10px;
		p {
			margin: 0 5px;
		}
	}

	.chiose::-webkit-scrollbar {
		display: none;
	}

	.chiosetop {
		display: flex;
		align-items: center;
		margin-bottom: 10px;

		p:first-child {
			margin-right: 10px;
		}
	}
}
</style>
<template>
	<div ref="homes">
		<titles titlename="试卷管理" titlecontent="这里可以看到试卷管理" :mbx="paths"></titles>
		<div class="manageselect">
			<div class="sclectlable">
				<div>
					<el-select clearable v-model="pagesobj.pro_guid" placeholder="请选择专业" @change="getpolist()">
						<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select clearable v-model="pagesobj.PR_GUID" placeholder="请选择岗位">
						<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
					</el-select>
				</div>
			</div>

			<div class="sclectlable">
				<div>
					<el-select clearable v-model="pagesobj.IL_GUID" clearable placeholder="请选择等级">
						<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
					</el-select>
				</div>
			</div>

			<div class="sclectlable">
				<div><el-input placeholder="请输入试卷名称" v-model="pagesobj.SPA_PaperTitle" clearable></el-input></div>
			</div>

			<div class="primarybtn"><el-button @click="gerlists()" type="primary" icon="el-icon-search">搜索</el-button></div>
		</div>
		<div class="resourbtn">
			<el-button type="primary" size="small" icon="fa fa-plus" @click="addeaxmins">添加试卷</el-button>
			<!-- <el-button type="primary" size="small" icon="el-icon-delete-solid" style="background-color: #04b57f;">添加试卷(自主组卷)</el-button> -->
		</div>
		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnum" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column :resizable="false" type="selection" width="55"></el-table-column>
							<el-table-column :resizable="false" label="试卷名称" prop="SPA_PaperTitle">
								<template slot-scope="scope">
									<p>{{ scope.row.SPA_PaperTitle }}</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="专业" prop="pro_name">
								<template slot-scope="scope">
									<p>{{ scope.row.pro_name }}</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="所属岗位" prop="PR_ProfessionalName" width="100"></el-table-column>
							<el-table-column :resizable="false" label="等级" prop="IL_LevelTitle" width="50"></el-table-column>
							<el-table-column :resizable="false" label="派卷情况" prop="DispatchStatus" width="80">
								<template slot-scope="scope">
									<p v-if="scope.row.DispatchStatus" style="color: #04b57f;">已派卷</p>
									<p v-if="!scope.row.DispatchStatus" style="color: #ff9901;">可派卷</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="考试时长(分钟)" prop="SPA_Duration" width="120">
								<template slot-scope="scope">
									<p style="text-align: center;width: 100%;">{{ scope.row.SPA_Duration }}</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="考试状态" prop="ExamStatus" width="120">
								<template slot-scope="scope">
									<p
										v-if="scope.row.ExamStatus == 1"
										style="text-align: center; color: #fff;background-color: #04b57f;width: 100px;margin: 0 auto;border-radius: 50px;"
									>
										未开始
									</p>
									<p
										v-if="scope.row.ExamStatus == 2"
										style="text-align: center;color: #fff;background-color: #ff9901;width: 100px;margin: 0 auto; border-radius: 50px;"
									>
										进行中
									</p>
									<p v-if="scope.row.ExamStatus == 3" style="text-align: center;background-color: #dee2e6;width: 100px; border-radius: 50px;margin: 0 auto;">
										已超时
									</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="考试时间" prop="SPA_SetExamTime">
								<template slot-scope="scope">
									<p v-if="scope.row.DispatchStatus">{{ scope.row.SPA_SetExamTime }}</p>
									<p v-if="!scope.row.DispatchStatus" style="color: red;">暂未派卷</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="考试结束时间" prop="SPA_EndTime">
								<template slot-scope="scope">
									<p v-if="scope.row.DispatchStatus">{{ scope.row.SPA_EndTime }}</p>
									<p v-if="!scope.row.DispatchStatus" style="color: red;">暂未派卷</p>
								</template>
							</el-table-column>

							<el-table-column :resizable="false" label="操作" fixed="right" width="300px">
								<template slot-scope="scope">
									<div style="text-align: center;">
										<el-button size="mini" style="background-color: #409eff;" @click="lookssresce(scope.row)">查看考试详情</el-button>
										<el-button size="mini" style="background-color: #409eff;" v-if="!scope.row.DispatchStatus" @click="editas(scope.row)">编辑</el-button>
										<el-button size="mini" style="background-color: #409eff;" @click="previeweaxmin(scope.row)">预览</el-button>
										<el-button
											size="mini"
											style="background-color: #04b57f;margin-top: 5px;margin-right: 5px;"
											@click="pfecxadmin(scope.row)"
											v-if="!scope.row.DispatchStatus"
										>
											派卷
										</el-button>
										<el-popconfirm title="是否删除该条记录？" @confirm="deleteresce(scope.row)">
											<el-button
												v-if="!scope.row.DispatchStatus"
												slot="reference"
												plain
												size="mini"
												style="margin-left: 5px;background-color: #ec0f25;margin-top: 5px;"
											>
												删除
											</el-button>
										</el-popconfirm>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesobj.pageSize }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							ref="elpagians"
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page.sync="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="派发试卷" center :visible.sync="dialogVisiblepf" :before-close="handleClose">
			<el-form :model="pfkaosobj" ref="ruleForm" label-width="140px" class="demo-ruleForm">
				<el-form-item label="试卷编号">
					<p>{{ pfkaosobj.SPA_PaperCode }}</p>
				</el-form-item>
				<el-form-item label="试卷名称">
					<p>{{ pfkaosobj.SPA_PaperTitle }}</p>
				</el-form-item>
				<el-form-item label="设置考核对象">
					<el-select style="width: 100%;" v-model="pfkaosobj.options" multiple placeholder="请选择班级">
						<el-option v-for="item in ClassList" :key="item.cla_guid" :label="item.cla_name" :value="item.cla_guid"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设置开始考试时间：">
					<el-date-picker
						v-model="pfkaosobj.SPA_SetExamTime"
						type="datetime"
						:picker-options="pickerOptions"
						@change="changetimers"
						format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
						placeholder="选择时间开始时间"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="设置结束考试时间：">
					<el-date-picker
						v-model="pfkaosobj.SPA_EndTime"
						type="datetime"
						format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
						placeholder="选择时间结束时间"
						:picker-options="pickerOptionsjz"
					></el-date-picker>
				</el-form-item>
				<el-form-item><el-button type="primary" @click="pffroms()">派卷</el-button></el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="添加试卷" center :visible.sync="dialogVisible" :before-close="handleClose">
			<div class="addstras">
				<div class="addstrascenter">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
						<el-form-item label="专业" prop="CA_GUID">
							<el-select v-model="ruleForm.CA_GUID" placeholder="请选择专业" @change="getpolist()">
								<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="岗位" prop="PR_GUID">
							<el-select v-model="ruleForm.PR_GUID" placeholder="请选择岗位">
								<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="等级" prop="IL_GUID">
							<el-select v-model="ruleForm.IL_GUID" clearable placeholder="请选择等级">
								<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="试卷名称" prop="SPA_PaperTitle"><el-input v-model="ruleForm.SPA_PaperTitle" placeholder="请输入试卷名称"></el-input></el-form-item>
						<!-- <el-form-item label="试卷总分值" prop="SPA_Scores"><el-input v-model="ruleForm.SPA_Scores" placeholder="请输入总分" style="width: 30%;"></el-input></el-form-item> -->
						<el-form-item label="考试总时间(分钟)" prop="SPA_Duration">
							<el-input
								v-model="ruleForm.SPA_Duration"
								type="number"
								oninput="if(value>999)value=999;if(value<0)value=0"
								min="0"
								placeholder="请输入总时间"
								style="width: 30%;"
							></el-input>
						</el-form-item>
						<el-form-item label="出题方式" v-if="isedit == 0">
							<el-radio-group v-model="ruleForm.ridios" size="small" @input="changeradios">
								<el-radio label="0" border>手动</el-radio>
								<el-radio label="1" border>自动</el-radio>
							</el-radio-group>
							<div class="ridioslist" v-if="ruleForm.ridios == '0'">
								<div class="qustridios">手动出题</div>
								<div class="qustiopn">
									<p>单选题:</p>
									<p class="chioce" @click="openchoices(1)">[ 选择题目 ]</p>
									<p>题目数量:{{ ruleForm.SPA_SingleCount }},</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_SingleScore"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计
										<span style="color: red;">{{ ruleForm.SPA_SingleCount * ruleForm.SPA_SingleScore }}</span>
										分
									</div>
								</div>
								<div class="qustiopn">
									<p>多选题:</p>
									<p class="chioce" @click="openchoices(2)">[ 选择题目 ]</p>
									<p>题目数量:{{ ruleForm.SPA_MultiCount }},</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_MultiScore"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计
										<span style="color: red;">{{ ruleForm.SPA_MultiCount * ruleForm.SPA_MultiScore }}</span>
										分
									</div>
								</div>

								<div class="qustiopn">
									<p>判断题:</p>
									<p class="chioce" @click="openchoices(3)">[ 选择题目 ]</p>
									<p>题目数量:{{ ruleForm.SPA_JudgeCount }},</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_JudgeScores"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计
										<span style="color: red;">{{ ruleForm.SPA_JudgeCount * ruleForm.SPA_JudgeScores }}</span>
										分
									</div>
								</div>
								<div style="width: 70%;text-align: right;">
									总分：
									<span style="color: red;font-size: 16px;">{{ otles }}</span>
								</div>
							</div>

							<div class="ridioslist" v-if="ruleForm.ridios == '1'">
								<div class="qustridios">自动出题</div>
								<div class="qustiopn">
									<p>单选题:</p>
									<p>
										题目数量:
										<input
											v-model="ruleForm.SPA_SingleCount"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
									</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_SingleScore"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计

										<span style="color: red;">{{ ruleForm.SPA_SingleCount * ruleForm.SPA_SingleScore }}</span>
										分
									</div>
								</div>
								<div class="qustiopn">
									<p>多选题:</p>
									<p>
										题目数量:
										<input
											v-model="ruleForm.SPA_MultiCount"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
									</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_MultiScore"
											style="margin: 0 5px;text-align: center;border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计
										<span style="color: red;">{{ ruleForm.SPA_MultiCount * ruleForm.SPA_MultiScore }}</span>
										分
									</div>
								</div>
								<div class="qustiopn">
									<p>判断题:</p>
									<p>
										题目数量:
										<input
											v-model="ruleForm.SPA_JudgeCount"
											style="margin: 0 5px;text-align: center;border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
									</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_JudgeScores"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计
										<span style="color: red;">{{ ruleForm.SPA_JudgeCount * ruleForm.SPA_JudgeScores }}</span>
										分
									</div>
								</div>
								<div style="width: 70%;text-align: right;">
									总分：
									<span style="color: red;font-size: 16px;">{{ otles }}</span>
								</div>
							</div>
						</el-form-item>

						<el-form-item label="出题方式" v-if="isedit == 1">
							<div class="ridioslist" v-if="ruleForm.SPA_TYPE == 1">
								<div class="qustridios">手动出题</div>
								<div class="qustiopn">
									<p>单选题:</p>
									<p class="chioce" @click="openchoices(1)">[ 选择题目 ]</p>
									<p>题目数量:{{ ruleForm.SPA_SingleCount }},</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_SingleScore"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计
										<span style="color: red;">{{ ruleForm.SPA_SingleCount * ruleForm.SPA_SingleScore }}</span>
										分
									</div>
								</div>
								<div class="qustiopn">
									<p>多选题:</p>
									<p class="chioce" @click="openchoices(2)">[ 选择题目 ]</p>
									<p>题目数量:{{ ruleForm.SPA_MultiCount }},</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_MultiScore"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计
										<span style="color: red;">{{ ruleForm.SPA_MultiCount * ruleForm.SPA_MultiScore }}</span>
										分
									</div>
								</div>

								<div class="qustiopn">
									<p>判断题:</p>
									<p class="chioce" @click="openchoices(3)">[ 选择题目 ]</p>
									<p>题目数量:{{ ruleForm.SPA_JudgeCount }},</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_JudgeScores"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计
										<span style="color: red;">{{ ruleForm.SPA_JudgeCount * ruleForm.SPA_JudgeScores }}</span>
										分
									</div>
								</div>
								<div style="width: 70%;text-align: right;">
									总分：
									<span style="color: red;font-size: 16px;">{{ otles }}</span>
								</div>
							</div>

							<div class="ridioslist" v-if="ruleForm.SPA_TYPE == 0">
								<div class="qustridios">自动出题</div>
								<div class="qustiopn">
									<p>单选题:</p>
									<p>
										题目数量:
										<input
											v-model="ruleForm.SPA_SingleCount"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
									</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_SingleScore"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计

										<span style="color: red;">{{ ruleForm.SPA_SingleCount * ruleForm.SPA_SingleScore }}</span>
										分
									</div>
								</div>
								<div class="qustiopn">
									<p>多选题:</p>
									<p>
										题目数量:
										<input
											v-model="ruleForm.SPA_MultiCount"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
									</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_MultiScore"
											style="margin: 0 5px;text-align: center;border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计
										<span style="color: red;">{{ ruleForm.SPA_MultiCount * ruleForm.SPA_MultiScore }}</span>
										分
									</div>
								</div>
								<div class="qustiopn">
									<p>判断题:</p>
									<p>
										题目数量:
										<input
											v-model="ruleForm.SPA_JudgeCount"
											style="margin: 0 5px;text-align: center;border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
									</p>
									<div>
										每道题分值:
										<input
											v-model="ruleForm.SPA_JudgeScores"
											style="margin: 0 5px;text-align: center;  border: 1px solid #ccc;width: 40px;height: 30px;"
											oninput="if(value<0)value=0"
											type="number"
										/>
										分,合计
										<span style="color: red;">{{ ruleForm.SPA_JudgeCount * ruleForm.SPA_JudgeScores }}</span>
										分
									</div>
								</div>
								<div style="width: 70%;text-align: right;">
									总分：
									<span style="color: red;font-size: 16px;">{{ otles }}</span>
								</div>
							</div>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="submitFormdr('ruleForm')" v-if="isedit == 0">立即增加</el-button>
							<el-button type="primary" @click="editFormdr('ruleForm')" v-if="isedit == 1">立即修改</el-button>
							<el-button @click="resetForm('ruleForm')">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>

			<el-dialog :title="chiocesname" custom-class="childdia" :visible.sync="innerVisible" :before-close="handleCloses" append-to-body label-position="top">
				<div class="demo-ruleForm">
					<el-form :model="ruleForm" :inline="true" ref="ruleForm">
						<el-form-item label="专业：" label-width="60px">
							<el-select
								v-model="ruleForm.CA_GUID"
								clearable
								placeholder="请选择专业"
								@change="
									inputpages();
									getpolist();
								"
							>
								<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="岗位：" label-width="70px">
							<el-select v-model="ruleForm.PR_GUID" clearable placeholder="请选择岗位" @change="inputpages()">
								<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="等级：" label-width="70px">
							<el-select v-model="ruleForm.IL_GUID" clearable placeholder="请选择等级" @change="inputpages()">
								<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="知识类别：">
							<el-radio-group v-model="ruleForm.SKY_GUID" @change="inputpages()">
								<el-radio label="">全部</el-radio>
								<el-radio v-for="item in knowledge" :key="item.SKY_GUID" :label="item.SKY_KonwledgeName">{{ item.SKY_KonwledgeName }}</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-form>

					<div class="chioscelist">
						<div class="chiosetop">
							<p>已选题目：</p>
							<p style="color: red;">
								已选
								<span v-if="dxpchiose.length > 0 && ischioceqution == 1">{{ dxpchiose.length }}</span>
								<span v-if="dxspchiose.length > 0 && ischioceqution == 2">{{ dxspchiose.length }}</span>
								<span v-if="pdpchiose.length > 0 && ischioceqution == 3">{{ pdpchiose.length }}</span>
								个题目
							</p>
						</div>

						<div class="chiose" v-if="dxpchiose.length > 0 && ischioceqution == 1">
							<p v-for="(item, index) in dxpchiose" :key="item.SerialNumber">{{ item.SerialNumber }};</p>
						</div>

						<div class="chiose" v-if="dxspchiose.length > 0 && ischioceqution == 2">
							<p v-for="(item, index) in dxspchiose" :key="item.SerialNumber">{{ item.SerialNumber }};</p>
						</div>

						<div class="chiose" v-if="pdpchiose.length > 0 && ischioceqution == 3">
							<p v-for="(item, index) in pdpchiose" :key="item.SerialNumber">{{ item.SerialNumber }};</p>
						</div>
					</div>
				</div>

				<div class="demo-ruleForm" style="margin: 20px 0;">
					<el-table :data="childtableData" ref="childtable" style="width: 100%" @select="selectionchange" @select-all="handleSelectAll">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column label="题目编号" prop="SerialNumber" width="80"></el-table-column>
						<el-table-column label="题型" prop="SQT_Name" width="120"></el-table-column>
						<el-table-column label="题目内容">
							<template slot-scope="scope">
								<p :title="scope.row.SQB_Question">{{ scope.row.SQB_Question }}</p>
							</template>
						</el-table-column>
						<el-table-column align="right" width="200px">
							<template slot="header" slot-scope="scope">
								<el-input v-model="childpagesobj.Content" @input="inputpages" size="mini" placeholder="输入编号搜索" />
							</template>
						</el-table-column>
					</el-table>
					<div class="boxright" style="padding-bottom: 20px;">
						<el-button type="primary" @click="submitqutions()">确认添加</el-button>
						<el-pagination
							background
							@current-change="changechildpagesobj"
							@size-change="changesizes"
							layout="prev, pager, next"
							:page-size="childpagesobj.pageSize"
							:current-page="childpagesobj.pageIndex"
							:total="childtotalall"
						></el-pagination>
					</div>
				</div>
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import {
	GetClassList,
	getGetProfList,
	getPositionList,
	changeGradeGet,
	PjPaperTestQuestions,
	GetTestPaperList,
	changeKonwledgeType,
	GetQuestionList,
	DeletePaper,
	zAddPaperTestQuestions,
	AddPaperTestQuestions,
	zUpdatePaperTest,
	UpdatePaperTest,
	PaperDetailsjs
} from '@/request/api/homesview/yunhomes/yunhom.js';

import { GetzyProfList } from '@/request/api/mange/mange.js';
import AppOptions from '@/config/AppOptions.vue';

import $ from 'jquery';

export default {
	data() {
		return {
			dialogVisible: false,
			innerVisible: false,
			dialogVisiblepf: false,
			// 标题
			paths: [
				{
					path: '/homesview/examinationmanage/examinationmanage',
					name: '试卷管理'
				}
			],
			tabsnum: 10,
			totalall: 10,
			tabindex: 1,
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				PCR_GUID: '',
				PR_GUID: '',
				SPA_PaperTitle: '',
				IL_GUID: '',
				pro_guid: ''
			},
			prolist: [],
			polist: [],
			gradeget: [],
			tabsnun: 1,
			ruleForm: {
				SPA_PaperTitle: '',
				SPA_Duration: '',
				PR_GUID: '',
				CA_GUID: '',
				IL_GUID: '',
				SKY_GUID: '',
				SPA_SingleScore: 0,
				SPA_MultiScore: 0,
				SPA_JudgeScores: 0,
				SPA_SingleCount: 0,
				SPA_MultiCount: 0,
				SPA_JudgeCount: 0,
				SPA_Scores: '',
				Datalist: [], // 自主组卷
				ridios: '0'
			},
			Singleall: 0,
			Multiall: 0,
			Judgeall: 0,
			rules: {
				// CA_GUID: [{ required: true, message: '请选择专业', trigger: 'blur' }],
				// PR_GUID: [{ required: true, message: '请选择岗位', trigger: 'blur' }],
				// IL_GUID: [{ required: true, message: '请选择等级', trigger: 'blur' }],
				SPA_PaperTitle: [{ required: true, message: '请输入试卷名称', trigger: 'blur' }],
				// SPA_Scores: [{ required: true, message: '请输入总分', trigger: 'blur' }],
				SPA_Duration: [{ required: true, message: '请输入总时间', trigger: 'blur' }],
				Datalist: [{ type: 'array', required: true, message: '请选择题目', trigger: 'change' }]
			},
			tableData: [],
			knowledge: [],
			// 表格
			childtableData: [],
			search: '',
			childpagesobj: {
				pageSize: 10,
				pageIndex: 1,
				sm_title: '',
				smt_guid: '',
				PR_GUID: '',
				PCR_RuleTitle: '',
				IL_GUID: '',
				pro_guid: '',
				PCT_IsState: '',
				SKY_GUID: '',
				SQB_IsDispark: '',
				SQT_GUID: '',
				StartTime: '',
				EndTime: '',
				Content: ''
			},
			childtotalall: 0,
			chiocesname: '选题[单选题]',
			dxpchiose: [],
			dxpchioselist: [],
			dxspchiose: [],
			dxspchioselist: [],
			pdpchiose: [],
			pdpchioselist: [],
			chiocelist: [],
			pchiose: [],
			ischioceqution: 0,
			pfkaosobj: {
				SPA_PaperCode: '',
				SPA_PaperTitle: '',
				options: [],
				SPA_SetExamTime: '',
				SPA_EndTime: ''
			},
			// 班级
			ClassList: [],
			pickerOptions: {
				disabledDate(v) {
					return v.getTime() < new Date().getTime() - 86400000; //  - 86400000是否包括当天
				}
			},
			pickerOptionsjz: {},
			exminxslistobj: {},
			isedit: 0
		};
	},
	components: {
		titles
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		if (AppOptions.appEmpty) {
			let homestop = $(this.$refs.homes).offset().top;
			let homesleft = $(this.$refs.homes).offset().left;
			if (homestop < 25 && localStorage.getItem('token') && homesleft < 200) {
				// console.log("刷新页面")
				// if (localStorage.getItem('token')) {
				// 	window.location.reload();
				// }
			}
		}

		this.init();
	},
	computed: {
		otles() {
			let otles = 0;
			otles =
				this.ruleForm.SPA_SingleCount * this.ruleForm.SPA_SingleScore +
				this.ruleForm.SPA_MultiCount * this.ruleForm.SPA_MultiScore +
				this.ruleForm.SPA_JudgeCount * this.ruleForm.SPA_JudgeScores;
			return otles;
		}
	},
	updated() {
		// console.log(this.dialogVisible, '显示');
	},
	methods: {
		handleCloses(done) {
			done();
		},
		init() {
			this.getprolist();
			this.getgrads();
			this.gerlists();
			this.getknowlist();
		},
		changetablesize() {
			this.pagesobj.pageSize = parseInt(this.tabsnum);
			if (this.pagesobj.pageSize * this.pagesobj.pageIndex > this.totalall) {
				let jsnums = this.pagesobj.pageSize * this.pagesobj.pageIndex;
				this.pagesobj.pageIndex = jsnums - this.totalall;
			}
			if (this.pagesobj.pageSize >= this.totalall) {
				this.pagesobj.pageIndex = 1;
			}
			this.gerlists();
		},
		calculatePagination(totalItems, itemsPerPage, currentPage) {
			// 计算总页数
			const totalPages = Math.ceil(totalItems / itemsPerPage);

			// 确保当前页码在有效范围内
			currentPage = Math.max(1, Math.min(currentPage, totalPages));

			// 计算起始索引和结束索引
			const startIndex = (currentPage - 1) * itemsPerPage;
			const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

			// 返回计算结果
			return {
				totalPages,
				currentPage,
				startIndex,
				endIndex
			};
		},
		addeaxmins() {
			// 添加试卷
			this.dialogVisible = true;

			this.ruleForm.SPA_SingleScore = 0;
			this.ruleForm.SPA_MultiScore = 0;
			this.ruleForm.SPA_JudgeScores = 0;
			this.ruleForm.SPA_SingleCount = 0;
			this.ruleForm.SPA_MultiCount = 0;
			this.ruleForm.SPA_JudgeCount = 0;
			this.ruleForm.ridios = '0';
			this.ruleForm.SPA_PaperTitle = '';
			this.ruleForm.SPA_Duration = '';
			this.ruleForm.PR_GUID = '';
			this.ruleForm.CA_GUID = '';
			this.ruleForm.IL_GUID = '';
			this.ruleForm.SKY_GUID = '';
			this.isedit = 0;
			this.ruleForm.Datalist = [];
			this.dxpchioselist = [];
			this.dxspchioselist = [];
			this.pdpchioselist = [];
			this.dxpchiose = [];
			this.dxspchiose = [];
			this.pdpchiose = [];
		},
		editFormdr(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					// console.log('提交', this.ruleForm);
					let otles = 0;
					otles =
						this.ruleForm.SPA_SingleCount * this.ruleForm.SPA_SingleScore +
						this.ruleForm.SPA_MultiCount * this.ruleForm.SPA_MultiScore +
						this.ruleForm.SPA_JudgeCount * this.ruleForm.SPA_JudgeScores;

					this.ruleForm.SPA_SingleScore = Number(this.ruleForm.SPA_SingleScore);
					this.ruleForm.SPA_MultiScore = Number(this.ruleForm.SPA_MultiScore);
					this.ruleForm.SPA_JudgeScores = Number(this.ruleForm.SPA_JudgeScores);

					this.ruleForm.SPA_MultiCount = Number(this.ruleForm.SPA_MultiCount);
					this.ruleForm.SPA_JudgeCount = Number(this.ruleForm.SPA_JudgeCount);
					this.ruleForm.SPA_SingleCount = Number(this.ruleForm.SPA_SingleCount);

					this.ruleForm.SPA_Scores = Number(otles);

					this.ruleForm.Datalist = [...this.dxpchioselist, ...this.dxspchioselist, ...this.pdpchioselist];
					// console.log(this.ruleForm.Datalist,'获取')
					if (otles == 0) {
						this.$message('请选择题目，并且选择分数');
						return;
					}

					if (this.ruleForm.ridios == '0') {
						// console.log('自主组件提交');
						zUpdatePaperTest(this.ruleForm).then(res => {
							if (res.data.code > 0) {
								this.$message.success(res.data.msg);

								this.resetForm('ruleForm');
								this.dialogVisible = false;

								this.gerlists();
							}
						});
					} else {
						// console.log('自动组件提交');
						UpdatePaperTest(this.ruleForm).then(res => {
							if (res.data.code > 0) {
								this.$message.success(res.data.msg);

								this.resetForm('ruleForm');
								this.dialogVisible = false;
								this.gerlists();
							}
						});
					}
				} else {
					return false;
				}
			});
		},
		// 编辑
		editas(itm) {
			// console.log(itm,"获取试卷详情")
			let exminxslistobj = {
				SPA_GUID: itm.SPA_GUID
			};
			this.ruleForm = JSON.parse(JSON.stringify(itm));

			PaperDetailsjs({
				SPA_GUID: exminxslistobj.SPA_GUID
			}).then(res => {
				// console.log(this.ruleForm,"获取")

				if (res.data.code >= 0) {
					this.ruleForm = res.data.data;
					// console.log(this.ruleForm, '获取');
					getPositionList(this.ruleForm.CA_GUID).then(res => {
						if (res.data.code > 0) {
							this.polist = res.data.data;
						}
					});
					this.isedit = 1;
					this.dxpchiose = res.data.data.SingleOptionlist;
					this.dxspchiose = res.data.data.MultipleOptionlist;
					this.pdpchiose = res.data.data.JudgeOptionlist;
					this.dxpchioselist = res.data.data.SingleOptionlist;
					this.dxspchioselist = res.data.data.MultipleOptionlist;
					this.pdpchioselist = res.data.data.JudgeOptionlist;

					this.dialogVisible = true;
				}
			});
		},
		// 查看预览删除,编辑
		lookssresce(itm) {
			this.$router.push(
				'/textorexamin/examinationmanage/examinkslis?SPA_GUID=' +
					itm.SPA_GUID +
					'&pro_name=' +
					itm.pro_name +
					'&PR_ProfessionalName=' +
					itm.PR_ProfessionalName +
					'&IL_LevelTitle=' +
					itm.IL_LevelTitle +
					'&SPA_PaperTitle=' +
					itm.SPA_PaperTitle +
					'&SPA_SetExamTime=' +
					itm.SPA_SetExamTime
			);
		},
		// 派发
		pffroms() {
			let pfkobjs = {
				SPA_GUID: this.pfkaosobj.SPA_GUID,
				SPA_SetExamTime: this.pfkaosobj.SPA_SetExamTime,
				SPA_EndTime: this.pfkaosobj.SPA_EndTime,
				cla_guid: []
			};
			let callist = [];
			this.pfkaosobj.options.forEach(itm => {
				callist.push({
					cla_guid: itm
				});
			});
			pfkobjs.cla_guid = callist;

			PjPaperTestQuestions(pfkobjs).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.dialogVisiblepf = false;
					this.pfkaosobj.SPA_PaperCode = '';
					this.pfkaosobj.SPA_PaperTitle = '';
					this.pfkaosobj.options = [];
					this.pfkaosobj.SPA_SetExamTime = '';
					this.pfkaosobj.SPA_EndTime = '';

					this.gerlists();
				}
			});
		},
		changetimers(val) {
			// console.log(this.pfkaosobj.SPA_SetExamTime,val,"时间")
			let deadlineTime = this.pfkaosobj.SPA_SetExamTime;
			let pickerOptions = {
				disabledDate(v) {
					return v.getTime() < new Date(deadlineTime || new Date()).getTime(); //  - 86400000是否包括当天
				}
			};
			this.pickerOptionsjz = pickerOptions;
		},
		pfecxadmin(itm) {
			this.pfkaosobj = itm;
			let claas = {
				si_guid: localStorage.getItem('siguid')
			};
			GetClassList(claas).then(res => {
				this.ClassList = res.data.data;
			});
			this.dialogVisiblepf = true;
		},
		editsresce(itm) {},
		// 删除
		deleteresce(re) {
			let review = {
				SPA_GUID: re.SPA_GUID
			};
			DeletePaper(review).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.gerlists();
				}
			});
		},
		// 预览试卷
		previeweaxmin(ite) {
			this.$router.push('/textorexamin/examinationmanage/examinxqtwo?SPA_GUID=' + ite.SPA_GUID);
		},

		// 查找
		inputpages() {
			this.childpagesobj.pageIndex = 1;
			this.gettionList(1);
		},

		// 选择
		selectionchange(list, row) {
			if (this.ischioceqution == 1) {
				// 单选
				if (this.dxpchiose.find(item => item.SQB_GUID == row.SQB_GUID)) {
					//下面这个filter方法就是删除的方法
					this.dxpchiose = this.dxpchiose.filter(item => item.SQB_GUID != row.SQB_GUID);
				} else {
					this.dxpchiose.push(row);
				}

				// console.log(this.dxpchiose);
			} else if (this.ischioceqution == 2) {
				// 多选
				if (this.dxspchiose.find(item => item.SQB_GUID == row.SQB_GUID)) {
					//下面这个filter方法就是删除的方法
					this.dxspchiose = this.dxspchiose.filter(item => item.SQB_GUID != row.SQB_GUID);
				} else {
					this.dxspchiose.push(row);
				}
			} else if (this.ischioceqution == 3) {
				// 判断
				if (this.pdpchiose.find(item => item.SQB_GUID == row.SQB_GUID)) {
					//下面这个filter方法就是删除的方法
					this.pdpchiose = this.pdpchiose.filter(item => item.SQB_GUID != row.SQB_GUID);
				} else {
					this.pdpchiose.push(row);
				}
			}
		},
		// 全选
		//该方法是当页全选的方法
		handleSelectAll(rows) {
			if (this.ischioceqution == 1) {
				if (rows.length) {
					rows.forEach(row => {
						if (!this.dxpchiose.find(item => item.SQB_GUID == row.SQB_GUID)) {
							this.dxpchiose.push(row);
						}
					});
				} else {
					this.childtableData.forEach(row => {
						this.dxpchiose = this.dxpchiose.filter(item => item.SQB_GUID != row.SQB_GUID);
					});
				}
			} else if (this.ischioceqution == 2) {
				if (rows.length) {
					rows.forEach(row => {
						if (!this.dxspchiose.find(item => item.SQB_GUID == row.SQB_GUID)) {
							this.dxspchiose.push(row);
						}
					});
				} else {
					this.childtableData.forEach(row => {
						this.dxspchiose = this.dxspchiose.filter(item => item.SQB_GUID != row.SQB_GUID);
					});
				}
			} else {
				if (rows.length) {
					rows.forEach(row => {
						if (!this.pdpchiose.find(item => item.SQB_GUID == row.SQB_GUID)) {
							this.pdpchiose.push(row);
						}
					});
				} else {
					this.childtableData.forEach(row => {
						this.pdpchiose = this.pdpchiose.filter(item => item.SQB_GUID != row.SQB_GUID);
					});
				}
			}
		},

		// 确认添加
		submitqutions() {
			// console.log('确认添加')
			if (this.ischioceqution == 1) {
				// console.log(this.dxpchiose)
				this.dxpchioselist = this.dxpchiose;
				this.ruleForm.SPA_SingleCount = this.dxpchioselist.length;
			} else if (this.ischioceqution == 2) {
				// console.log(this.dxspchiose)
				this.dxspchioselist = this.dxspchiose;
				this.ruleForm.SPA_MultiCount = this.dxspchioselist.length;
			} else {
				// console.log(this.pdpchiose)
				this.pdpchioselist = this.pdpchiose;
				this.ruleForm.SPA_JudgeCount = this.pdpchioselist.length;
			}
			// console.log(this.ruleForm.SPA_MultiCount)

			this.innerVisible = false;
		},
		gerlists() {
			GetTestPaperList(this.pagesobj).then(res => {
				// console.log(res)
				if (res.data.code > 0) {
					this.tableData = res.data.data.list;
					this.totalall = res.data.data.totalCount;
				} else {
					this.tableData = [];
					this.totalall = 0;
				}
			});
		},
		// 切换出题
		changeradios() {},
		// 组卷
		submitFormdr(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					// console.log('提交', this.ruleForm);
					let otles = 0;
					otles =
						this.ruleForm.SPA_SingleCount * this.ruleForm.SPA_SingleScore +
						this.ruleForm.SPA_MultiCount * this.ruleForm.SPA_MultiScore +
						this.ruleForm.SPA_JudgeCount * this.ruleForm.SPA_JudgeScores;

					this.ruleForm.SPA_SingleScore = Number(this.ruleForm.SPA_SingleScore);
					this.ruleForm.SPA_MultiScore = Number(this.ruleForm.SPA_MultiScore);
					this.ruleForm.SPA_JudgeScores = Number(this.ruleForm.SPA_JudgeScores);

					this.ruleForm.SPA_MultiCount = Number(this.ruleForm.SPA_MultiCount);
					this.ruleForm.SPA_JudgeCount = Number(this.ruleForm.SPA_JudgeCount);
					this.ruleForm.SPA_SingleCount = Number(this.ruleForm.SPA_SingleCount);

					this.ruleForm.SPA_Scores = Number(otles);

					this.ruleForm.Datalist = [...this.dxpchioselist, ...this.dxspchioselist, ...this.pdpchioselist];
					// console.log(this.ruleForm.Datalist,'获取')
					if (otles == 0) {
						this.$message('请选择题目，并且选择分数');
						return;
					}

					if (this.ruleForm.ridios == '0') {
						// console.log('自主组件提交');
						zAddPaperTestQuestions(this.ruleForm).then(res => {
							if (res.data.code > 0) {
								this.$message.success(res.data.msg);

								this.resetForm('ruleForm');
								// console.log(this.dialogVisible,"显示英寸111")
								this.gerlists();

								this.dialogVisible = false;
							}
						});
					} else {
						// console.log('自动组件提交');
						AddPaperTestQuestions(this.ruleForm).then(res => {
							if (res.data.code > 0) {
								this.$message.success(res.data.msg);

								this.resetForm('ruleForm');

								// console.log(this.dialogVisible,"显示英寸222")
								this.gerlists();

								this.dialogVisible = false;
							}
						});
					}
				} else {
					return false;
				}
			});
		},
		resetForm(formName) {
			// this.ruleForm = {};
			// 重置
			this.$refs[formName].resetFields();
			this.addeaxmins();
		},
		getprolist() {
			this.prolist = [];
			if (localStorage.getItem('uiguid') == 'f2b9986b57074d2cb2dadd07f6ee62bb') {
				getGetProfList().then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						if (this.pagesobj.pro_guid !== '') {
							this.getpolist();
						}
					}
				});
			} else {
				GetzyProfList(localStorage.getItem('siguid')).then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						if (this.pagesobj.pro_guid !== '') {
							this.getpolist();
						}
					}
				});
			}
		},
		getpolist() {
			let proguid = '';
			if (this.ruleForm.CA_GUID != '') {
				proguid = this.ruleForm.CA_GUID;
			} else {
				proguid = this.pagesobj.pro_guid;
			}
			this.ruleForm.PR_GUID = '';
			this.pagesobj.PR_GUID = '';
			this.polist = [];
			if (proguid == '') {
				return;
			}
			console.log(proguid, '岗位');
			getPositionList(proguid).then(res => {
				if (res.data.code > 0) {
					this.polist = res.data.data;
				}
			});
		},
		getgrads() {
			changeGradeGet().then(res => {
				// console.log("获取等级",res)
				this.gradeget = res.data.data;
			});
		},
		// 知识类别
		getknowlist() {
			let knowobj = {
				SKY_KonwledgeName: ''
			};
			changeKonwledgeType(knowobj).then(res => {
				this.knowledge = res.data.data;
			});
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		indexMethod(index) {
			return index + 1;
		},
		changecurr(val) {
			// console.log(val, '页码');
			this.pagesobj.pageIndex = val;
			this.gerlists();
		},
		changechildpagesobj(val) {
			// console.log(val,'页码')
			this.childpagesobj.pageIndex = val;
			this.gettionList(1);
		},
		changesizes(val) {
			// console.log(val,'调速')
		},

		gettionList(i = 0) {
			this.childpagesobj.pro_guid = this.ruleForm.CA_GUID;
			this.childpagesobj.PR_GUID = this.ruleForm.PR_GUID;
			this.childpagesobj.IL_GUID = this.ruleForm.IL_GUID;
			this.childpagesobj.SKY_GUID = this.ruleForm.SKY_GUID;

			GetQuestionList(this.childpagesobj).then(res => {
				this.childtableData = res.data.data.list;
				this.childtotalall = res.data.data.totalCount;
				// console.log("题目",this.childtableData)
				if (i == 1) {
					// console.log(this.dxpchiose, '获取单选1111');
					if (this.ischioceqution == 1) {
						this.$nextTick(() => {
							this.childtableData.forEach((item, index) => {
								if (this.dxpchiose.findIndex(v => v.SQB_GUID == item.SQB_GUID) >= 0) {
									// console.log('获取单选',item);
									this.$refs.childtable.toggleRowSelection(item, true);
								}
							});
						});
					} else if (this.ischioceqution == 2) {
						this.$nextTick(() => {
							this.childtableData.forEach((item, index) => {
								if (this.dxspchiose.findIndex(v => v.SQB_GUID == item.SQB_GUID) >= 0) {
									// console.log('获取', this.$refs.childtable);
									this.$refs.childtable.toggleRowSelection(item, true);
								}
							});
						});
					} else {
						this.$nextTick(() => {
							this.childtableData.forEach((item, index) => {
								if (this.pdpchiose.findIndex(v => v.SQB_GUID == item.SQB_GUID) >= 0) {
									// console.log('获取', this.$refs.childtable);
									this.$refs.childtable.toggleRowSelection(item, true);
								}
							});
						});
					}
				}
			});
		},

		getRowKeys(row) {
			return row.SQB_GUID;
		},
		openchoices(i) {
			// if (this.ruleForm.CA_GUID == '') {
			// 	this.$message('请选择专业');
			// 	return;
			// }

			// if (this.ruleForm.PR_GUID == '') {
			// 	this.$message('请选择岗位');
			// 	return;
			// }

			// if (this.ruleForm.IL_GUID == '') {
			// 	this.$message('请选择等级');
			// 	return;
			// }

			if (i == 1) {
				this.chiocesname = '选题[单选题]';
				this.childpagesobj.SQT_GUID = '677E84ABA24746228F2957B26C25347E';
			} else if (i == 2) {
				this.chiocesname = '选题[多选题]';
				this.childpagesobj.SQT_GUID = '4EBE5A8F10644FBF8FE61151567F90A3';
			} else if (i == 3) {
				this.chiocesname = '选题[判断题]';
				this.childpagesobj.SQT_GUID = 'BCDC7963A8A34C5788501CFCDE87487D';
			}
			this.ischioceqution = i;
			if (this.isedit == 0) {
				this.gettionList();
			} else {
				this.gettionList(1);
			}

			this.innerVisible = true;
		}
	}
};
</script>
